export interface IFileCommand {
  execute(): void;
}
